module.exports = __webpack_public_path__ + "static/4-5fc4cfe9e7391174b8397b152a314025.jpg";